<template>
  <div class="app" :class="{ 'app--list': isShow || isApps }">
    <label-popup
      v-if="showLabels"
      :selectedLabelId="app.label"
      @close-popup="showLabels = false"
      @create-label="createLabel"
      @update-label="updateLabel"
      @delete-label="deleteLabel"
      @change-app-label="changeApplicationLabel"
    ></label-popup>
    <div
      v-if="!isApps"
      class="app-item__menu"
      :class="{ 'app-item__menu--list': isShow }"
      :tabindex="0"
      @blur="close"
    >
      <img
        src="@/assets/images/ellipsis.svg"
        alt="others"
        class="mt-4 cursor-pointer z-[1]"
        @click="showActions = !showActions"
      />
      <div v-if="showActions" class="app-item__other-actions">
        <ul>
          <li @click="renameApp">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <path
                d="M8.84006 2.40006L3.36673 8.1934C3.16006 8.4134 2.96006 8.84673 2.92006 9.14673L2.6734 11.3067C2.58673 12.0867 3.14673 12.6201 3.92006 12.4867L6.06673 12.1201C6.36673 12.0667 6.78673 11.8467 6.9934 11.6201L12.4667 5.82673C13.4134 4.82673 13.8401 3.68673 12.3667 2.2934C10.9001 0.913397 9.78673 1.40006 8.84006 2.40006Z"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.92676 3.3667C8.21342 5.2067 9.70676 6.61337 11.5601 6.80003"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 14.6667H14"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p>{{ $t("button.app.rename") }}</p>
          </li>
          <li @click="showLabels = true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M2.78001 10.2L5.80001 13.22C7.04001 14.46 9.05334 14.46 10.3 13.22L13.2267 10.2934C14.4667 9.05337 14.4667 7.04003 13.2267 5.79337L10.2 2.78003C9.56668 2.1467 8.69334 1.8067 7.80001 1.85337L4.46668 2.01337C3.13334 2.07337 2.07334 3.13337 2.00668 4.46003L1.84668 7.79337C1.80668 8.69337 2.14668 9.5667 2.78001 10.2Z"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.33317 8.00008C7.25365 8.00008 7.99984 7.25389 7.99984 6.33341C7.99984 5.41294 7.25365 4.66675 6.33317 4.66675C5.4127 4.66675 4.6665 5.41294 4.6665 6.33341C4.6665 7.25389 5.4127 8.00008 6.33317 8.00008Z"
                stroke-linecap="round"
              />
            </svg>
            <p>
              {{ labelEditText }}
            </p>
          </li>
          <li @click="copyToClipboard">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M10.6666 8.59992V11.3999C10.6666 13.7333 9.73325 14.6666 7.39992 14.6666H4.59992C2.26659 14.6666 1.33325 13.7333 1.33325 11.3999V8.59992C1.33325 6.26659 2.26659 5.33325 4.59992 5.33325H7.39992C9.73325 5.33325 10.6666 6.26659 10.6666 8.59992Z"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                opacity="0.4"
                d="M14.6666 4.59992V7.39992C14.6666 9.73325 13.7333 10.6666 11.3999 10.6666H10.6666V8.59992C10.6666 6.26659 9.73325 5.33325 7.39992 5.33325H5.33325V4.59992C5.33325 2.26659 6.26659 1.33325 8.59992 1.33325H11.3999C13.7333 1.33325 14.6666 2.26659 14.6666 4.59992Z"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p>{{ $t(copyText) }}</p>
          </li>
          <li @click="removeItem">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            >
              <path
                d="M13.7813 4.04956C11.5959 3.833 9.3975 3.72144 7.20563 3.72144C5.90625 3.72144 4.60688 3.78706 3.3075 3.91831L1.96875 4.04956"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.57812 3.38656L5.7225 2.52688C5.8275 1.90344 5.90625 1.4375 7.01531 1.4375H8.73469C9.84375 1.4375 9.92906 1.92969 10.0275 2.53344L10.1719 3.38656"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.3703 6.12305L11.9437 12.7315C11.8715 13.7618 11.8125 14.5624 9.98151 14.5624H5.76839C3.93745 14.5624 3.87839 13.7618 3.8062 12.7315L3.37964 6.12305"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.77905 10.9531H8.96437"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.23438 8.32812H9.51563"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p>{{ $t("button.app.delete") }}</p>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="!isShow && !isApps" class="app-item">
      <div class="flex-1 h-full relative inline-block">
        <transition name="slide-up" mode="out-in">
          <div
            v-if="isFront"
            class="app-item__front flex flex-col gap-3 flex-none items-center w-full h-full p-4"
          >
            <div class="w-full items-start flex">
              <div
                v-if="app.label !== null"
                class="h-[22px] flex items-center px-4 rounded"
                :style="labelColor"
              >
                <span class="text-center text-xs font-semibold">
                  {{ app.label.title }}
                </span>
              </div>
            </div>
            <div class="flex flex-col gap-3 justify-center items-center flex-1">
              <div
                class="p-[18px] bg-greyscale-100 dark:bg-[#282C34] rounded-full"
              >
                <img
                  v-if="theme"
                  src="@/assets/images/app-item-dark-mode.svg"
                  alt="app-item"
                  class="w-10 h-10"
                />
                <img
                  v-else
                  src="@/assets/images/app-item.svg"
                  alt="app-item"
                  class="w-10 h-10"
                />
              </div>
              <span
                class="text-xs text-secondary-base dark:text-secondary-100 overflow-hidden overflow-ellipsis whitespace-nowrap w-[300px] text-center"
                >{{ app.title }}
              </span>
            </div>
          </div>
          <div v-else class="app-item__back absolute w-full h-full">
            <div class="flex items-center gap-1">
              <div
                class="p-[10px] bg-greyscale-100 rounded-full dark:bg-[#282C34]"
              >
                <img
                  v-if="theme"
                  src="@/assets/images/app-item-dark-mode.svg"
                  alt="app-item"
                  class="w-[18px] h-[18px]"
                />
                <img
                  v-else
                  src="@/assets/images/app-item.svg"
                  alt="app-item"
                  class="w-[18px] h-[18px]"
                />
              </div>
              <p
                class="text-[18px] text-secondary-base dark:text-primary-white"
              >
                {{ mapAppType() }}
              </p>
            </div>
            <div class="info-wrapper">
              <div class="app-item__info">
                <p>{{ $t("app.spec.name") }}</p>
                <p>:</p>
                <span
                  class="overflow-ellipsis overflow-hidden whitespace-nowrap"
                >
                  {{ mapAppTitle() }}
                </span>
                <p>{{ $t("app.spec.size") }}</p>
                <p>:</p>
                <div class="flex flex-row items-center overflow-hidden">
                  <span
                    class="overflow-ellipsis overflow-hidden whitespace-nowrap"
                  >
                    {{ getAppSize(app.size) }}
                  </span>
                </div>
                <p>{{ $t("app.spec.uploadedby") }}</p>
                <p>:</p>
                <span>{{ app.createdBy }}</span>
                <p>{{ $t("app.spec.uploadedat") }}</p>
                <p>:</p>
                <span>{{ app.createdAt | moment("D MMMM YYYY - hh:mm") }}</span>
                <p>{{ $t("app.spec.url") }}</p>
                <p>:</p>
                <div class="flex flex-row items-center overflow-hidden">
                  <span
                    class="overflow-ellipsis overflow-hidden whitespace-nowrap"
                    v-tooltip="app.appUrl"
                  >
                    {{ app.appUrl }}
                  </span>
                  <CopyButton :value="app.appUrl" class="!h-4"></CopyButton>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div @click="isFront = !isFront" class="app-item__actions">
        <Button
          @click.native.stop.prevent="removeItem"
          v-if="!isFront"
          class="bg-[#F8FAFD] dark:bg-[#482D41] ball h-7 w-7 p-0 flex items-center justify-center"
        >
          <img v-if="theme" src="@/assets/images/trash-dark.svg" alt="trash" />
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
          >
            <path
              d="M14.6145 4.75781C12.4292 4.54125 10.2308 4.42969 8.03888 4.42969C6.7395 4.42969 5.44013 4.49531 4.14075 4.62656L2.802 4.75781"
              stroke="#21242B"
              stroke-width="1.3125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.41138 4.09481L6.55575 3.23513C6.66075 2.61169 6.7395 2.14575 7.84856 2.14575H9.56794C10.677 2.14575 10.7623 2.63794 10.8608 3.24169L11.0051 4.09481"
              stroke="#21242B"
              stroke-width="1.3125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.2035 6.8313L12.777 13.4397C12.7048 14.47 12.6457 15.2707 10.8148 15.2707H6.60164C4.7707 15.2707 4.71164 14.47 4.63945 13.4397L4.21289 6.8313"
              stroke="#21242B"
              stroke-width="1.3125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.6123 11.6614H9.79762"
              stroke="#FF4747"
              stroke-width="1.3125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.06763 9.03638H10.3489"
              stroke="#FF4747"
              stroke-width="1.3125"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </Button>
        <div class="app-item__actions__wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#2B5DE5"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="min-w-[18px] feather feather-chevron-down"
            :class="{ arrow_up: !isFront }"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
          <span class="app-item__actions__text">
            {{ $t("button.app.details") }}
          </span>
        </div>
      </div>
    </div>
    <div
      v-else
      :class="{ 'app-item--modal': isApps }"
      class="app-item--list mb-[14px]"
      @click="selectApp"
    >
      <div class="app-item--list-wrapper">
        <div
          class="flex gap-3 items-center justify-center app-item--list__item w-32"
        >
          <div v-if="isApps" class="relative">
            <Radio
              class="indicator"
              :value="app.id"
              @change="getAppId"
              ref="radio"
            />
          </div>
          <div class="svg-wrapper--list-item">
            <img
              v-if="theme"
              src="@/assets/images/app-item-dark-mode.svg"
              alt="app-item"
              class="w-[18px] h-[18px]"
            />
            <img
              v-else
              src="@/assets/images/app-item.svg"
              alt="app-item"
              class="w-[18px] h-[18px]"
            />
          </div>
          <p class="text-[18px] font-medium dark:!text-primary-white">
            {{ mapAppType() }}
          </p>
        </div>
        <div class="app-item--list__item w-40">
          <p class="font-medium text-xs" v-tooltip="app.title">
            {{ mapAppTitle() }}
          </p>
        </div>
        <div class="app-item--list__item w-32 flex gap-3 items-center">
          <div class="flex items-center">
            <p class="app-item--list__item font-medium text-xs">
              {{ getAppSize(app.size) }}
            </p>
          </div>
        </div>
        <div class="app-item--list__item w-32">
          <p class="font-medium text-xs">
            {{ app.createdBy }}
          </p>
        </div>
        <div class="app-item--list__item w-32">
          <div
            v-if="app.label !== null"
            class="h-[22px] flex items-center px-4 rounded overflow-hidden w-fit"
            :style="labelColor"
          >
            <p
              class="text-center text-xs font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap max-w-[96px]"
              v-tooltip="app.label.title"
            >
              {{ app.label.title }}
            </p>
          </div>
        </div>
        <div class="app-item--list__item w-32">
          <p class="font-medium text-xs">
            {{ app.createdAt | moment("D MMMM YYYY") }}
          </p>
        </div>
        <div v-if="isApps">
          <div
            class="app-item--list__item h-7 w-7 flex items-center justify-center dark:bg-[#9519264d] rounded-full cursor-pointer"
            @click="removeItem"
          >
            <img
              v-if="theme"
              src="@/assets/images/trash-dark.svg"
              alt="trash"
            />
            <img v-else src="@/assets/images/trash.svg" alt="trash" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import CopyButton from "@/components/CopyButton";
import LabelPopup from "@/components/LabelPopup";
import Radio from "@/components/Radio";
export default {
  name: "ApplicationItem",
  components: { Button, CopyButton, LabelPopup, Radio },
  props: {
    app: {
      type: Object,
      required: true,
    },
    isShow: Boolean,
    isApps: Boolean,
  },
  data() {
    return {
      isFront: true,
      showActions: false,
      showLabels: false,
      copyText: "button.app.copy",
    };
  },
  created() {
    this.theme = this.getTheme === "dark";
  },
  methods: {
    ...mapActions(["emitConfirmData"]),
    mapAppType() {
      return this.app.title.split(".").pop();
    },
    mapAppTitle() {
      const lastDotIndex = this.app.title.lastIndexOf(".");
      if (lastDotIndex === -1) {
        return this.app.title;
      } else {
        return this.app.title.substring(0, lastDotIndex);
      }
    },
    selectApp() {
      this.$refs.radio.$el.click();
    },
    close() {
      this.showActions = false;
    },
    createLabel(value) {
      this.$emit("create-label", value);
    },
    updateLabel(value) {
      this.$emit("update-label", value);
    },
    deleteLabel(value) {
      this.$emit("delete-label", value);
    },
    changeApplicationLabel(value) {
      this.$emit("change-app-label", { id: this.app.id, labelId: value });
      this.getApplications();
    },
    renameApp() {
      this.emitConfirmData({
        header: this.$t("confirm.app_rename.header"),
        actions: {
          confirm: this.$t("button.general.confirm"),
          cancel: this.$t("button.general.cancel"),
        },
        showInput: true,
        defaultInput: this.app.title.slice(0, -4),
        callback: (isConfirm, input) => {
          if (isConfirm) {
            this.$emit("rename-app", {
              id: this.app.id,
              title: `${input}.${this.app.title.split(".").pop()}`,
            });
          }
        },
      });
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.app.appUrl).then(() => {
        this.copyText = "button.general.copied";
        setTimeout(() => {
          this.copyText = "button.app.copy";
        }, 1000);
      });
    },
    removeItem() {
      this.emitConfirmData({
        header: this.$t("confirm.delete_app.header"),
        textTitle: this.app.title,
        text: this.$t("confirm.delete_app.text"),
        actions: {
          confirm: this.$t("button.general.delete"),
          cancel: this.$t("button.general.cancel"),
        },
        callback: (isConfirm) => {
          if (isConfirm) {
            this.$emit("remove-item", this.app.id);
          }
        },
      });
    },
    getAppId(id) {
      this.$emit("appId", id);
    },
    getAppSize(size) {
      return size < 1 ? "<1mb" : size + "mb";
    },
  },
  computed: {
    ...mapGetters(["getTheme"]),
    labelColor() {
      return this.app.label !== null
        ? `background-color: ${this.app.label.color}2E;color: ${this.app.label.color}`
        : "";
    },
    labelEditText() {
      return this.app.label !== null
        ? this.$t("button.app.change")
        : this.$t("button.app.add");
    },
  },
};
</script>

<style scoped>
@import "index.module.css";
</style>
